import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./dist/main.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Root from "./routes/application/root";
import JoinUs from "../src/routes/application/components/Pages/Join/JoinUs";
import Job from "../src/routes/application/components/Pages/Join/Job/Job";
import JobApplication from "./routes/application/components/Pages/Join/Job/Application/JobApplication";
import AuthLayout from "./routes/hr_dashboard/layout/auth";
import DashboardLayout from "./routes/hr_dashboard/layout/dashboard";
import LoginPage from "./routes/hr_dashboard/pages/auth/login";
import DashboardOverview from "./routes/hr_dashboard/pages/dashboard/overview";
import Applicants from "./routes/hr_dashboard/pages/dashboard/applicants";
import ApplicantsCredential from "./routes/hr_dashboard/pages/dashboard/applicants-credential";
import Interviews from "./routes/hr_dashboard/pages/dashboard/interview";
import OfferDetail from "./routes/hr_dashboard/pages/dashboard/offer-detail";
import OnboardingTracker from "./routes/hr_dashboard/pages/dashboard/onboarding-tracker";
import OnboardingProcess from "./routes/hr_dashboard/pages/dashboard/onboarding-process";
import HrEmployee from "./routes/hr_dashboard/pages/dashboard/hr-employees";
import HrQTraining from "./routes/hr_dashboard/pages/dashboard/hr-quarterly-training";
import HrTermination from "./routes/hr_dashboard/pages/dashboard/hr-termination";
import HrEvaluation from "./routes/hr_dashboard/pages/dashboard/hr-evaluation";
import SettingsPage from "./routes/hr_dashboard/pages/dashboard/settings";
import InterviewsCredential from "./routes/hr_dashboard/pages/dashboard/interviews-credential";
import NotificationPage from "./routes/hr_dashboard/pages/dashboard/notifications";
import FileAttentionTable from "./routes/hr_dashboard/components/Dashboard/Tables/FileAttentionTable";
import NewApplicantFileAttentionTable from "./routes/hr_dashboard/components/Dashboard/Tables/NewApplicantFileAttentionTable";
import OnboardingOrientation from "./routes/hr_dashboard/pages/dashboard/onboarding-orientation";
import Offers from "./routes/hr_dashboard/pages/dashboard/offers";
import SetPasswordPage from "./routes/hr_dashboard/pages/auth/setPassword";
import CandidateDashboardLayout from "./routes/hr_dashboard/layout/candidate-dashboard";
import CandidateOverviewPage from "./routes/hr_dashboard/pages/candidate-dashboard/profile";
import CandidateDashboard from "./routes/hr_dashboard/pages/candidate-dashboard/dashboard";

const router = createBrowserRouter([
  /** Application routes - Author: Ampong */
  {
    path: "/",
    element: <Root root={true} />,
    children: [
      {
        index: true,
        element: <JoinUs />,
      },
      {
        path: "jobs/:jobId",
        element: <Job />,
      },
    ],
  },
  {
    path: "/jobs/:jobId/application",
    element: <Root root={false} />,
    children: [
      {
        index: true,
        element: <JobApplication />,
      },
    ],
  },

  /** HR Dashboared routes - Author: Pius */
  // Add your routes here
  {
    element: <AuthLayout />,
    path: "/auth",
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "set-password",
        element: <SetPasswordPage />,
      },
    ],
  },

  {
    element: <DashboardLayout />,
    path: "/dashboard",
    children: [
      {
        path: "",
        element: <DashboardOverview />,
      },

      {
        path: "applicants",
        element: <Applicants />,
      },

      {
        path: "applicants/credential",
        element: <ApplicantsCredential />,
      },

      {
        path: "interviews",
        element: <Interviews />,
      },

      {
        path: "interviews/credential",
        element: <InterviewsCredential />,
      },

      {
        path: "offers",
        element: <Offers />,
      },
      {
        path: "offers/:id",
        element: <OfferDetail />,
      },

      {
        path: "offers/need-attention",
        element: <FileAttentionTable />,
      },
      {
        path: "onboarding/tracker",
        element: <OnboardingTracker />,
      },
      {
        path: "onboarding/process",
        element: <OnboardingProcess />,
      },
      {
        path: "onboarding/orientation",
        element: <OnboardingOrientation />,
      },
      {
        path: "hr/employees",
        element: <HrEmployee />,
      },
      {
        path: "hr/eval-assessment",
        element: <HrEvaluation />,
      },
      {
        path: "hr/quarterly-training",
        element: <HrQTraining />,
      },
      {
        path: "hr/termination",
        element: <HrTermination />,
      },
      {
        path: "notifications",
        element: <NotificationPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
    ],
  },

  {
    element: <CandidateDashboardLayout />,
    path: "/candidate/dashboard",
    children: [
      {
        path: "",
        element: <CandidateDashboard />,
      },
      {
        path: "profile",
        element: <CandidateOverviewPage />,
      },
      {
        path: "need-attention",
        element: <NewApplicantFileAttentionTable />,
      },
      {
        path: "notifications",
        element: <NotificationPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
